export const formatWithSymbol = (value: number | string, symbol?:string): string => {
  const separateSymbol = symbol ?? ' ';
  const s = String(value).trim();
  if (!s) return s;

  const sign = s.startsWith('-') ? '-' : '';
  const raw = sign ? s.slice(1) : s;

  const [intPartRaw, fracPart] = raw.split('.');

  const intPart = intPartRaw.replace(/\D/g, '');
  if (!intPart) return sign + raw;

  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, separateSymbol);
  return sign + (fracPart !== undefined ? `${formattedInt}.${fracPart}` : formattedInt);
};
